import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
var style = xcss({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center'
});
var RelatedLinksResolvingViewOld = function RelatedLinksResolvingViewOld() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: style,
    testId: "related-links-resolving-view"
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: 'large',
    testId: "related-links-resolving-view-spinner"
  }));
};
export default RelatedLinksResolvingViewOld;